import React, { useState } from 'react';
import PropTypes from 'prop-types';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import ToggleBox from 'components/toggler-components/ToggleBox';
import ToggleBoxHeader from 'components/toggler-components/ToggleBoxHeader';
import ToggleBoxBody from 'components/toggler-components/ToggleBoxBody';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import { useTranslation } from 'react-i18next';

function DataSourceSelection({ properties, dataSourcesList, handleChange, columnValueList }) {
  const { t } = useTranslation();
  const [toggler, setToggler] = useState(false);
  const dataSourceValues = dataSourcesList.map(({ displayValue, value }) => ({
    displayValue,
    value,
  }));
  const dataSourceValuesMap = Object.fromEntries(
    dataSourceValues.map((v) => [v.value, v.displayValue]),
  );
  const columnValuesMap = Object.fromEntries(columnValueList.map((v) => [v.value, v.displayValue]));

  return (
    <ToggleBox classes='mt-3'>
      <ToggleBoxHeader
        show={toggler}
        toggleBoxOpen={() => setToggler(!toggler)}
        title='form_internal_data_source_details'
      />
      <ToggleBoxBody show={toggler} classes='d-flex flex-column gap-2'>
        <MultiLevelSelect
          name='dataSource'
          options={{ children: dataSourceValues }}
          value={[]}
          displayName='form_data_source'
          handleChange={(name, value) => handleChange(name, value[0])}
          toggleClasses='p-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
          toggleComponent={
            <>
              <label className='theme-size-0_9 cursor-pointer '>
                {properties.dataSource !== ''
                  ? dataSourceValuesMap[properties.dataSource]
                  : t('select_select')}
              </label>
              <img src={chevronGreyIcon} className='rotate-180' />
            </>
          }
          fullWidth
        />

        <div className='d-flex gap-3 mb-1'>
          <div className='w-100'>
            <MultiLevelSelect
              name='displayColumn'
              options={{ children: columnValueList }}
              value={[]}
              displayName='form_field_display_column'
              handleChange={(name, value) => handleChange(name, value[0])}
              toggleClasses='p-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
              toggleComponent={
                <>
                  <label className='theme-size-0_9 cursor-pointer '>
                    {properties.displayColumn !== ''
                      ? columnValuesMap[properties.displayColumn]
                      : t('select_select')}
                  </label>
                  <img src={chevronGreyIcon} className='rotate-180' />
                </>
              }
              disabled={properties.dataSource === ''}
            />
          </div>
          <div className='w-100'>
            <MultiLevelSelect
              name='valueColumn'
              options={{ children: columnValueList }}
              value={[]}
              displayName='form_field_value_column'
              handleChange={(name, value) => handleChange(name, value[0])}
              toggleClasses='p-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
              toggleComponent={
                <>
                  <label className='theme-size-0_9 cursor-pointer '>
                    {properties.valueColumn !== ''
                      ? columnValuesMap[properties.valueColumn]
                      : t('select_select')}
                  </label>
                  <img src={chevronGreyIcon} className='rotate-180' />
                </>
              }
              disabled={properties.dataSource === ''}
            />
          </div>
        </div>
      </ToggleBoxBody>
    </ToggleBox>
  );
}
DataSourceSelection.propTypes = {
  properties: PropTypes.object.isRequired,
  columnValueList: PropTypes.array.isRequired,
  dataSourcesList: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};
export default DataSourceSelection;
